import React from "react";
import PropTypes from "prop-types";
import { List } from "immutable";
import { Card, Row, Col, 
    Spin 
} from "antd";
import { Table } from "components/table";
import {
    ACCOUNT_STATEMENT_COLS,
    STATE_STATUS
} from "constants";

const { UNFETCHED, FETCHING } = STATE_STATUS;

class AccountStatementView extends React.Component {
    render() {
        const { data, status } = this.props;
        if (!status || status === UNFETCHED || status === FETCHING) {
            return (
                <div
                    className={
                        "d-flex justify-content-center align-items-center"
                    }
                    style={{
                        minHeight: "400px"
                    }}>
                    <Spin size="large" />
                </div>
            );
        }
        
        return (
            <React.Fragment>
                <Card className={"padless-card"}>
                    <Row>
                        <Col span={24}>
                            <Table
                                title={"Account Statement"}
                                columns={ACCOUNT_STATEMENT_COLS}
                                data={data || new List([])}
                                showTopSection={true}
                                showXlsxBtn={true}
                                showDownloadBtn={false}
                                showFilterBtn={true}
                                downloadAccountStmt={this.props.downloadAccountStmt}
                                keyFilter={"id"}
                                toggleAccountFilterModal={this.props.openFilterModal}
                                csvSuffix={"acc_stmt"}
                                scrollX={"100%"}
                                pagination={false}
                                tablePagination={true}
                                spanConfig={{
                                    title: 4,
                                    filters: 8,
                                    btnSpan: 12,
                                    btnOffset: 0
                                }}
                                showFooter={false}
                                startDate={this.props.startDate}
                                endDate={this.props.endDate}
                                showTime={true}
                            />
                        </Col>
                    </Row>
                </Card>
            </React.Fragment>
        );
    }
}

AccountStatementView.propTypes = {
    data: PropTypes.array,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    downloadAccountStmt: PropTypes.func,
    openFilterModal: PropTypes.func,
    caseId: PropTypes.number,
    accounts: PropTypes.object,
    status: PropTypes.string
};

export default AccountStatementView;